import { Action, Dispatch } from 'redux'
import { closeCautionModalAction } from 'reducks/modal/actions'

const closeCautionModal = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(closeCautionModalAction())
  }
}

export default closeCautionModal
